// extracted by mini-css-extract-plugin
export var logo = "_jt-2";
export var logoWrapper = "_jt-1";
export var strip = "_jt-0";